import axios from 'axios'

const CommunicationsService = {
  async listUserCdr(params = {}) {
    return axios.get('cdr/user', { params })
  },

  async listCustomerCdr(params = {}) {
    return axios.get('cdr/customer', { params })
  },

  async getCdr(id) {
    return axios.get(`cdr/${id}`)
  },

  async listUserVoicemail(params = {}) {
    return axios.get('voicemessages/user', { params })
  },

  async getVoicemail(id) {
    return axios.get(`voicemessages/${id}`)
  },

  async updateVoicemail(id, payload = {}) {
    return axios.put(`voicemessages/${id}`, payload)
  },

  async deleteVoicemail(id) {
    return axios.delete(`voicemessages/${id}`)
  },

  async getVoicemailRecording(id) {
    return axios.get(`voicemessages/${id}/recording`, { responseType: 'blob' })
  }
}

export default CommunicationsService
